<template>
  <component :is="layout" :style="{ backgroundColor: bgColor }">
    <router-view />
    <Toaster position="top-right" closeButtonPosition="top-right" />
  </component>
</template>

<script>
import AuthLayout from './layouts/auth-layout.vue'
import HomeLayout from './layouts/home-layout.vue'
import CompanyLayout from './layouts/company-layout.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import LoadingLayout from './layouts/loading-layout.vue'
import { Toaster } from '@/components/ui/sonner'
import 'vue-sonner/style.css'

export default {
  name: 'App.vue',
  components: { AuthLayout, HomeLayout, CompanyLayout, LoadingLayout, Toaster },
  mixins: [responsiveMixin],
  computed: {
    layout() {
      return this.$route.meta.layout === undefined
        ? 'loading-layout'
        : this.$route.meta.layout
    },
    bgColor() {
      if (this.isMobile) {
        return this.$route.meta.bgColor || '#F9FBFF'
      } else {
        return this.$route.meta.bgColorDesktop || '#F9FBFF'
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../css/app/base';
</style>
